import * as z from 'zod';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateCPF } from '../../../../utils/validations';

function getAgeFromBrDate(value?: string): number | null {
  if (!value || !/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
    return null;
  }

  const [day, month, year] = value.split('/').map(Number);
  const birthDate = new Date(year, month - 1, day);

  if (
    birthDate.getFullYear() !== year ||
    birthDate.getMonth() !== month - 1 ||
    birthDate.getDate() !== day
  ) {
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasNotHadBirthdayThisYear =
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate());

  if (hasNotHadBirthdayThisYear) {
    age -= 1;
  }

  return age;
}

export const dependentsSchema = z
  .object({
    name: z.optional(
      z
        .string()
        .min(1, { message: 'Campo obrigatorio' })
        .refine(val => validaNomeCompleto(val), {
          message: 'Digite o nome completo sem abreviacoes (ex: Joao da Silva)',
        }),
    ),
    birthDate: z
      .string()
      .min(1, { message: 'Campo obrigatorio' })
      .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
        message: 'Formato invalido (use DD/MM/AAAA)',
      })
      .refine(
        value => {
          const [dia, mes, ano] = value.split('/').map(Number);
          const date = new Date(ano, mes - 1, dia);

          return (
            date.getFullYear() === ano &&
            date.getMonth() === mes - 1 &&
            date.getDate() === dia
          );
        },
        { message: 'Data de nascimento invalida' },
      ),
    civilStatus: z.string().min(1, { message: 'Campo obrigatorio' }),
    gender: z.string().min(1, { message: 'Campo obrigatorio' }),
    parentage: z.string().min(1, { message: 'Campo obrigatorio' }),
    cpf: z.optional(
      z.string().refine(val => !val || validateCPF(val.replace(/\D/g, '')), {
        message: 'CPF invalido',
      }),
    ),
    mothersName: z.optional(
      z
        .string()
        .min(1, { message: 'Campo obrigatorio' })
        .refine(val => validaNomeCompleto(val), {
          message: 'Digite o nome completo sem abreviacoes (ex: Joao da Silva)',
        }),
    ),
    plano: z.string().optional(),
    plano_vl: z.string().optional(),
  })
  .superRefine((dependent, ctx) => {
    const age = getAgeFromBrDate(dependent.birthDate);
    const cpf = dependent.cpf?.replace(/\D/g, '') || '';

    if (age !== null && age >= 16 && !cpf) {
      ctx.addIssue({
        code: 'custom',
        message: 'CPF obrigatorio para dependente com 16 anos ou mais',
        path: ['cpf'],
      });
    }
  });
